import { extend } from "vee-validate";
// eslint-disable-next-line @typescript-eslint/camelcase
import { required, alpha_dash } from "vee-validate/dist/rules";
import { readEntries } from "@/store/uniabc/getters";
import store from "@/store";
import { api } from "@/api";
import { readGitLabInfo } from "@/store/gitlab/getters";

extend("required", required);
extend("alpha_dash", alpha_dash);

extend("labelNotExists", value => {
  if (!Object.keys(readEntries(store)).includes(value)) {
    return true;
  }

  return "Label already exists!";
});

extend("conformsLabel", value => {
  const labelRegex = /^[A-Za-z0-9]+$/;

  if (value.match(labelRegex)) {
    return true;
  }

  return "Label does not conform spec ([A-Za-z0-9]+)!";
});

extend("branchAlreadyExists", {
  validate: value =>
    new Promise(resolve => {
      const projID = readGitLabInfo(store).projectId;
      api
        .getBranchesOfProject(projID)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then(data => data.map((b: any) => b.name))
        .then(branches => {
          if (!branches.includes(value)) {
            resolve({ valid: true });
          } else {
            resolve({ valid: false });
          }
        });
    }),
  message: `Branch already exists`
});

// extend('invalidChars', {
//     validate(value, {fieldType}) {
//         let validRegEx = /.+/;
//         switch (fieldType) {
//             case 'label':
//             case 'key':
//                 validRegEx = /\w+/
//         }
//
//     },
//     params: ['fieldType']
// })
